import React, { Component } from 'react';

import Form from '@search/components/form';
import Ads from '@search/components/ads';
import Results from '@search/components/results';
import DetailPanel from '@search/components/detailpanel';

class App extends Component {
  constructor(props) {
    super(props);

    this.containerRef = React.createRef();

    this.state = {
      isSearchActive: false,
      hasGotData: false,
    };
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside.bind(this));
  }

  componentDidUpdate() {
    if (this.state.isSearchActive && !this.state.hasGotData) {
      this.setState(prevState => {
        return { hasGotData: true };
      });
      this.props.getData();
    }
  }

  getOpenSearchDataAttr() {
    return 'data-open-search';
  }

  getOpenSearchClass() {
    return 'fv-nav__item--search';
  }

  open() {
    this.setState({
      isSearchActive: true,
    });
  }

  handleClickOutside(e) {
    if (
      e.target.parentElement.hasAttribute(this.getOpenSearchDataAttr()) ||
      e.target.parentElement.className
        .split(' ')
        .includes(this.getOpenSearchClass())
    ) {
      this.open();
    }
  }

  close() {
    const scrollY = document.body.style.top;
    document.body.style.position = '';
    document.body.style.top = '';
    window.scrollTo(0, parseInt(scrollY || '0') * -1);
    document.body.classList.remove('no-scroll');
    document.querySelector('[data-app-search]').classList.remove('is-active');
    this.props.clearSearch();
    this.setState({
      isSearchActive: false,
    });
  }

  render() {
    let results;
    if (this.state.isSearchActive) {
      results = <Results />;
    }
    return (
      <div className="fv-search-app">
        <div className="fv-search-app__close" onClick={this.close.bind(this)}>
          <i className="icon-close" />
        </div>
        <Form />
        <Ads />
        {results}
        <DetailPanel />
      </div>
    );
  }
}

export default App;
